<ng-container *ngIf="selectionType && loanTypes">
  <ng-container *ngIf="!allowsExpiredProduct; else allowsExpired">
    <boi-form-radio-button [labelName]="referenceDataLabels.SelectAProductId" [(value)]="selectionType"
      [propertyNames]="['ProductSelectionTypeCode']" [optionList]="referenceDataOptionLists.ProductSelection"
      [contextualHelpName]="referenceDataContextualHelps.ProductSelection" [isFieldDisabled]="isDisabled">
    </boi-form-radio-button>

    <ng-container
      *ngIf="isBrokerCase && isBuyToLet && (referenceDataLabels.BtlAffordabilityNotificationMsg|localizeLabel)">
      <boi-form-information-box [decoration]="'exclamation-mark'" (clickEvent)="openAffordabilityCalculator($event)"
        [message]="referenceDataLabels.BtlAffordabilityNotificationMsg">
      </boi-form-information-box>
      <kendo-dialog class="vo-modal"
      [title]="referenceDataLabels.AffordabilityCalculatorTitle | localizeLabel"
        *ngIf="isAffordabilityCalculatorOpened" (keyup.escape)="isAffordabilityCalculatorOpened=false"
        (close)="isAffordabilityCalculatorOpened=false">
        <iframe width="550" height="500" frameBorder="0" [src]="affordabilityCalculatorUrl"></iframe>
        <kendo-dialog-actions class="modal-buttons">
          <div class="left-column">
            <a (click)="isAffordabilityCalculatorOpened=false"
              [innerHtml]="referenceDataLabels.CancelId | localizeLabel" class="link vo-secondary-button-1"></a>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </ng-container>

    <ng-container *ngIf="selectionType === referenceDataOptionLists.ProductSelectionByType">
      <div class="application-form-input">
        <boi-contextual-help-container [contextualHelpName]="referenceDataLabels.ProductType"
          [ngClass]="{'has-errors': hasErrorProductType}">
          <boi-validation-error [propertyNames]="['ProductType']" (errorChange)="hasErrorProductType=$event">
          </boi-validation-error>
          <kendo-textbox-container class="form-element app">
            <div class="form-label app" [boiRequiredFormField]="referenceDataLabels.ProductType">
              <label [for]="referenceDataLabels.ProductType"
                [innerHtml]="referenceDataLabels.ProductType | localizeLabel"></label>
            </div>
            <div class="form-input-container dropdown-width-large vo-form-option-list--large">
              <div>
                <kendo-dropdownlist [data]="loanTypes" valuePrimitive="true" textField="Value"
                  id="referenceDataLabels.ProductType" valueField="Code" [(ngModel)]="selectedLoanType"
                  [disabled]="isDisabled" (ngModelChange)="onUpdatedLoanType(true)"
                  [defaultItem]="{Value:referenceDataLabels.PleaseSelect | localizeLabel, Code: undefined}">
                </kendo-dropdownlist>
              </div>
            </div>
            <boi-tooltip [title]="referenceDataLabels.ProductType"></boi-tooltip>
          </kendo-textbox-container>
        </boi-contextual-help-container>
      </div>
      <div class="application-form-input">
        <boi-contextual-help-container [contextualHelpName]="referenceDataLabels.ProductName"
          [ngClass]="{'has-errors': hasErrorProductName}">
          <boi-validation-error [propertyNames]="[
          'WithdrawnProduct',
          'ClosedProduct',
          'InvalidProduct',
          'ApplicationProduct_0.WithdrawnProduct',
          'ApplicationProduct_0.ClosedProduct',
          'ApplicationProduct_0.InvalidProduct']" (errorChange)="hasErrorProductName=$event">
          </boi-validation-error>
          <kendo-textbox-container class="form-element app">
            <div class="form-label app" [boiRequiredFormField]="referenceDataLabels.ProductName">
              <label [for]="referenceDataLabels.ProductName"
                [innerHtml]="referenceDataLabels.ProductName | localizeLabel"></label>
            </div>
            <div class="form-input-container dropdown-width-large vo-form-option-list--large">
              <div>
                <kendo-dropdownlist [data]="productList" valuePrimitive="true" textField="ProductName"
                  id="referenceDataLabels.ProductName" valueField="ProductID" [(ngModel)]="selectedProductId"
                  (selectionChange)="resetSolicitorDetails()"
                  [disabled]="isDisabled || !productList || productList.length === 0"
                  [defaultItem]="{ProductName:referenceDataLabels.PleaseSelect | localizeLabel, ProductID: undefined}">
                </kendo-dropdownlist>
              </div>
            </div>
            <boi-tooltip [title]="referenceDataLabels.ProductName"></boi-tooltip>
          </kendo-textbox-container>
        </boi-contextual-help-container>
      </div>

      <div class="app-form-row">
        <div class="app-form-row-label-cell bo-label-text">
          <span [innerHtml]="referenceDataLabels.ProductCode | localizeLabel"></span>
        </div>
        <div class="app-form-row-value-cell">
          <span>{{product?.ProductCode}}</span>
        </div>
      </div>

    </ng-container>
    <ng-container *ngIf="selectionType === referenceDataOptionLists.ProductSelectionByCode">
      <ng-container *ngTemplateOutlet="allowsExpired"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #allowsExpired>
    <div class="application-form-input">
      <boi-contextual-help-container [ngClass]="{'has-errors': hasErrorProductCode || isProductCodeInvalid}"
        [contextualHelpName]="referenceDataLabels.ProductCodeRequired">
        <ng-container *ngIf="isProductCodeInvalid">
          <div class="error-message">{{referenceDataLabels.InvalidProductCode|localizeLabel}}</div>
        </ng-container>
        <boi-validation-error [propertyNames]="[
        'WithdrawnProduct',
        'ClosedProduct',
        'InvalidProduct',
        'ApplicationProduct_0.WithdrawnProduct',
        'ApplicationProduct_0.ClosedProduct',
        'ApplicationProduct_0.InvalidProduct']" (errorChange)="hasErrorProductCode=$event">
        </boi-validation-error>
        <kendo-textbox-container class="form-element app">
          <div class="form-label app" [boiRequiredFormField]="referenceDataLabels.ProductCodeRequired">
            <label [for]="referenceDataLabels.ProductCodeRequired"
              [innerHtml]="referenceDataLabels.ProductCodeRequired|localizeLabel"></label>
          </div>
          <div class="form-input-container">
            <input [id]="referenceDataLabels.ProductCodeRequired" [(ngModel)]="productCode" [disabled]="isDisabled"
              (blur)="onBlurProductCode()" [autocomplete]="'off'" [maxlength]="40" kendoTextBox />
          </div>
          <boi-tooltip [tooltipName]="referenceDataLabels.ProductCodeRequired"></boi-tooltip>
        </kendo-textbox-container>
      </boi-contextual-help-container>
    </div>

    <div class="app-form-row">
      <div class="app-form-row-label-cell bo-label-text">
        <span [innerHtml]="referenceDataLabels.ProductType | localizeLabel"></span>
      </div>
      <div class="app-form-row-value-cell">
        <span>{{product?.LoanTypeCode}}</span>
      </div>
    </div>
  </ng-template>

  <div class="app-form-row height-auto">
    <div class="app-form-row-label-cell bo-label-text">
      <span [innerHtml]="referenceDataLabels.ProductOverview | localizeLabel"></span>
    </div>
    <div class="app-form-row-value-cell">
      <span *ngIf="product?.Description" class="tag bo-label-text" [innerHtml]="product?.Description"></span>
    </div>
  </div>

  <ng-container *ngIf="product?.IsAboutToExpire || product?.IsWithdrawn">
    <boi-form-information-box [shouldNotLocalize]="true" [decoration]="'exclamation-mark'"
      [message]="productWarningMessage">
    </boi-form-information-box>
  </ng-container>
</ng-container>

<ng-container *ngIf="product && isProductSpecialFeatureDialogOpen">
  <boi-product-special-features-dialog class="vo-modal vo-modal--standard" [(opened)]="isProductSpecialFeatureDialogOpen"
    [titleLabel]="referenceDataLabels.ProductPickerSpecialFeatureTitle"
    [confirmationLabel]="referenceDataLabels.ProductPickerSpecialFeatureContent"
    [confirmationButtonLabel]="referenceDataLabels.ConfirmProductWithSpecialFeature"
    [data]="product.ProductSpecialFeatures" (cancelAction)="cancelProductSpecialFeatures()">
  </boi-product-special-features-dialog>
</ng-container>
